import { useMemo } from 'react'

import { ComplaintsReportSourceChoices } from '@/apollo/graphql'
import { IOption } from '@/types'
import { t } from '@/i18n'

export const useOptions = () => {
  const reportSourceOptions: IOption<ComplaintsReportSourceChoices>[] = useMemo(
    () =>
      Object.entries(ComplaintsReportSourceChoices).map(([k, v]) => ({
        label: t(k),
        value: v,
      })),
    [],
  )

  const locationOptions: IOption<string>[] = useMemo(() => {
    const locations = [
      'נהריה',
      'אשדוד',
      'ערד',
      'בת ים',
      'בני ברק',
      'חולון',
      'ירושלים',
      'חדרה',
      'נצרת',
      'אילת',
      'טבריה',
      'צפת',
      'תל אביב',
      'עכו',
      'ראשון לציון',
      'נתניה',
      'רמת גן',
      'אשקלון',
      'רעננה',
      'הרצליה',
      'קריית אונו',
      'חיפה',
      'פתח תקווה',
      'כפר סבא',
      'רחובות',
      'באר שבע',
      'לוד',
    ]

    return locations.map(loc => ({ label: loc, value: loc }))
  }, [])

  return {
    reportSourceOptions,
    locationOptions,
  }
}
